<app-header></app-header>

<!-- Main content -->
<div class="justify-content-center info-warning" *ngIf="!loggedIn">
  Login or Signup to view contact details, book Appointments and live chat feature
</div>
<div class="container-fluid profile-section" *ngIf="midwife">
  <div class="row justify-content-center ">
    <div class="col-11 col-sm-10">
      <div class="row">
        <div class="col-lg-8">
          <app-profile-detail [midwife]="midwife"></app-profile-detail>
          <app-my-recent-blogs [midwife]="midwife"></app-my-recent-blogs>
          <app-reviews-and-ratings [midwife]="midwife"></app-reviews-and-ratings>
          <app-people-reviews [midwife]="midwife"></app-people-reviews>
        </div>
        <div class="col-lg-4">
          <app-book-an-appointment [midwifeId]="midwifeId"></app-book-an-appointment>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row mt-5" *ngIf="loading">
  <div class="spinner-border loader" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>

<app-footer></app-footer>

<!-- Booking Request Modal Starts -->
<app-appointment-modal></app-appointment-modal>
<!-- Booking Request Modal Ends -->